
import _ from 'lodash';


const deslug = string =>  {
	return _.startCase(string);
}


export default deslug;
